module.exports = __webpack_public_path__ + "static/media/Pearl.790d61a3.png";